// page Not found area
import React from 'react';

const NotFound = () => {
    return (
        <div className="container">
            <div className="py-5 my-5 bg-light">
                <h2>404</h2>
                <p>Page Not Found</p>
            </div>
        </div>
    );
};

export default NotFound;